import { BBSpinner, Button, Flex, Text } from '@rocket/ui';
import { useEffect, useState } from 'react';
import { LuPartyPopper } from 'react-icons/lu';
import { useFtueHost } from '../host';
import type { PlaybookRule } from '../onboarding-api';
import { getPlaybookRules } from '../onboarding-api';

interface Props {
  playbookId?: string;
  playbookName?: string;
  onFinish: (playbookId?: string) => void;
}

export function OnboardingComplete({ playbookId, playbookName, onFinish }: Props) {
  const { bbAxios } = useFtueHost();
  const [rules, setRules] = useState<Array<PlaybookRule> | null>(null);

  useEffect(() => {
    if (!playbookId) {
      return;
    }
    getPlaybookRules(bbAxios, playbookId)
      .then(setRules)
      .catch(() => setRules([]));
  }, [bbAxios, playbookId]);

  const uniqueSections = rules ? [...new Set(rules.flatMap((r) => r.sections))].length : 0;

  return (
    <Flex.V align="center" justify="center" gap="6" p="8" flex="1">
      <LuPartyPopper size={48} color="var(--chakra-colors-green-fg)" />
      <Flex.V align="center" gap="2">
        <Text fontWeight="700" fontSize="xl">
          You're all set!
        </Text>
        {playbookId && rules === null ? (
          <BBSpinner size="sm" />
        ) : (
          <Flex.V align="center" gap="1">
            {playbookName && (
              <Text fontWeight="600" fontSize="md">
                {playbookName}
              </Text>
            )}
            <Text color="fg.muted" fontSize="sm" textAlign="center">
              {rules && rules.length > 0
                ? `${rules.length} rule${rules.length !== 1 ? 's' : ''} across ${uniqueSections} section${uniqueSections !== 1 ? 's' : ''}`
                : 'Your playbook is ready to use.'}
            </Text>
          </Flex.V>
        )}
      </Flex.V>
      <Button
        colorPalette="gray"
        onClick={() => onFinish(playbookId)}
        disabled={playbookId ? rules === null : false}
      >
        Start Using BlackBoiler
      </Button>
    </Flex.V>
  );
}
